{
  "#UPLOAD_ARCHIVE_VOUCHER": {
    "TITLE": "Archivbeleg hochladen",
    "FIND_VOUCHER": {
      "TITLE": "Archivbeleg hochladen",
      "SUBTITLE": "Beleg suchen",
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "Barcode",
      "SUBMIT": "Bestätigen",
      "OR": "Oder",
      "SCAN_HEADER": "Beleg scannen",
      "SCAN_DESCRIPTION": "Beleg mithilfe des integrierten Scanners suchen"
    },
    "UPLOAD_PICTURE": {
      "TITLE": "Archivbeleg hochladen",
      "NUMBER": "Belegnummer",
      "DATE": "Belegdatum",
      "CUSTOMER": "Kunde",
      "NAME": "Belegname",
      "UPLOAD": "Bilder hochladen"
    },
    "MESSAGES": {
      "NO_VOUCHER_FOUND": "Es konnte kein Beleg zu diesem Barcode gefunden werden"
    }
  }
}
